import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GridApi, GridOptions } from "ag-grid-community";
import * as moment from "moment";
import { AgNumberCountComponent, AgSelectActionCellRendererComponent } from "src/app/core/components";
import { LogHelperService } from "src/app/core/services/log-helper.service";
import { GatepassRequestProcess, GatePassRequestType } from "../gatepass-request-process.model";
import { GatePassRequestsService } from "../../gate-pass-requests.service";
import { GLOBAL } from "src/app/app.globals";
import { ApiCallService } from "src/app/service/api-call.service";
import { DataShareService } from "src/app/service/data-share.service";

const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};

@Component({
  selector: 'app-license-selection',
  templateUrl: './license-selection.component.html',
  styleUrls: ['./license-selection.component.css']
})
export class LicenseSelectionComponent implements OnInit {

  @Input() licenseList: any[] = [];
  @Input() stepData: GatepassRequestProcess;
  @Input() globalSettings: any[];
  @Input() alertMessages: any[];
  @Input() selectedPlantDetail: any;
  @Input() selectedWorkOrderDetail: any;

  @Output() handleSave: EventEmitter<any>;
  @Output() handleClose: EventEmitter<void>;
  @Output() handlePrevAction: EventEmitter<void>;

  currentStep: number = 1;
  allStepDataObj: any;
  columnDefs: any[];
  gridOptions: GridOptions;
  gridAPI: GridApi;
  stateCapacityExceedStatus: any;
  showStatus: any;
  verifyLicense: any;

  private parentLicenseList: any[] = [];

  parentLicenseCode: number;
  isCheckValidation: boolean;
  isHideRemaining: boolean;
  isHideSkip: boolean = false;
  isUmbrellaConcept: boolean = false
  isIndividualConcept: boolean = false
  isCheckConcept: boolean = false
  licenceExpireMessage: any;
  selectActiveMsg: any;
  selectedLicenseData: any[] = []
  noremainingMsg: any;
  constructor(
    private logHelperService: LogHelperService,
    private gatepassService: GatePassRequestsService,
    private apiCall: ApiCallService,
    private dataShareService: DataShareService
  ) {
    this.handleSave = new EventEmitter<any>();
    this.handleClose = new EventEmitter<void>();
    this.handlePrevAction = new EventEmitter<void>();
    this.isCheckValidation = false;
    this.createColumnDef();
    this.createGridOptions();
  }

  ngOnInit(): void {
    this.gatepassService.getRequestTypeText(this.stepData);
    // this.showStatus = this.globalSettingCodes .find(item => item.Code === browserWindowEnv.LICENSE_SELECTION_STATUS_SHOW).Value;
    // this.verifyLicense = this.globalSettingCodes .find(item => item.Code === browserWindowEnv.VERIFY_LICENSE).Value;
    // const workOrderSetting = this.globalSettingCodes .find(item => item.Code === browserWindowEnv.RemainingPerson.licenseSelectionCode);
    // if (workOrderSetting && workOrderSetting.Value === '1') {
    //   this.isCheckValidation = true;
    // }

    this.licenceExpireMessage = this.alertMessages.find((i: any) => i.Short_Code == "MSG195_8")
    this.noremainingMsg = this.alertMessages.find((i: any) => i.Short_Code == "MSG195_1")
    this.selectActiveMsg = this.alertMessages.find((i: any) => i.Short_Code == "MSG195_3")

    // this.getGlobalCodes();
    this.globalSettingCodes = GLOBAL.GLOBALCODES
    this.setGlobalSetting();
  }

  globalSettingCodes: any
  // getGlobalCodes() {
  //   this.apiCall.globalSettingCode().subscribe((res: any) => {
  //   });
  // }
  setGlobalSetting() {
    this.showStatus = this.globalSettingCodes.find(item => item.Code === "MOD52PG195REQLICSTATUS").Value;
    this.verifyLicense = this.globalSettingCodes.find(item => item.Code === "MOD152PG195LICAPVV01").Value;
    const workOrderSetting = this.globalSettingCodes.find(item => item.Code === "MOD52PG195REQLICCAP");
    if (workOrderSetting && workOrderSetting.Value === '1') {
      this.isCheckValidation = true;
    }

    if (workOrderSetting && workOrderSetting.Value === '0') {
      this.isHideRemaining = true
    }
    else {
      this.isHideRemaining = false
    }

    let allLicenseExpired: boolean = false;
    let licenseExpiredCount: number = 0;
    if (this.licenseList.length !== 0) {
      this.licenseList.forEach((license: any) => {
        if (license.Status !== 'Active') {
          licenseExpiredCount++;
        }
      })

      if (this.licenseList.length === licenseExpiredCount) {
        allLicenseExpired = true;
      }
    }
    this.createColumnDef();
  }

  onNextAction(): void {
  }

  onCloseAction(): void {
    this.selectedLicenseData = []
    this.handleClose.emit();
  }

  onPrevAction(): void {
    if (this.parentLicenseCode) {
      this.licenseList = this.parentLicenseList;
      this.parentLicenseCode = null;
      return;
    }
    this.handlePrevAction.emit();
  }

  onSkipAction(): void {
    if (this.stepData.contractorType === 'SUB_CONTRACTORS_MAN' && this.stepData.requestType == 103) {
      this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: false });
      this.checkConditionWithSkip();
    } else {
      this.checkConditionWithSkip();
    }
  }

  checkConditionWithSkip() {
    let checkCondition = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
    let concept = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICUMB').Value;
    let msg = this.alertMessages.find(item => item.Short_Code === 'MSG195_8').MSG;
    msg = msg.replaceAll('{State}', this.selectedPlantDetail.State);
    msg = msg.replaceAll('{Value}', this.selectedPlantDetail.LicenseMaxValue);
    if (this.stepData.contractorType === 'CONTRACTORS_MAN') {
      if (checkCondition == '1' && this.stepData.requestType == 103 || checkCondition == '1' && this.stepData.requestType == 104 && this.stepData.isNew) {
        if (this.licenseList.length > 0) {
          this.licenseList.forEach((element: any) => {
            if (element.Status == "Active") {
              this.logHelperService.logError({
                message: `Please Select Active License`,
                html: true
              })
              this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: false });
            } else {
              if ((this.selectedWorkOrderDetail.Person - this.selectedWorkOrderDetail.Remaining) < this.selectedPlantDetail.LicenseMaxValue) {
                this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
              } else {
                this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: false });
                this.logHelperService.logError({
                  message: msg,
                  html: true
                })
              }
            }
          });
        } else {
          this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
        }

      } else if (checkCondition == '0') {
        this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
      } else {
        this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
      }
    }

    if (this.stepData.contractorType === 'SUB_CONTRACTORS_MAN') {
      if (checkCondition == '1' && this.stepData.requestType == 103 || checkCondition == '1' && this.stepData.requestType == 104 && this.stepData.isNew) {
        if (this.licenseList.length > 0) {
          if (concept == '1') {
            if (this.selectedLicenseData.length === 0 && this.isIndividualConcept == false) {
              this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
            } else if (this.selectedLicenseData.length === 0 && this.isIndividualConcept == true) {
              this.logHelperService.logError({
                message: `Please select any license.`,
                html: true
              });
              return
              // this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: false });
            }
          } else if (concept == '0') {
            if (this.selectedLicenseData.length === 0 && this.isUmbrellaConcept == true || this.selectedLicenseData.length === 0 && this.isUmbrellaConcept == false) {
              this.logHelperService.logError({
                message: `Please select any license.`,
                html: true
              });
              this.isUmbrellaConcept = true
              return
              this.selectedLicenseData = []
              this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: false });
            }
            if (!this.selectedLicenseData == null && this.isUmbrellaConcept == false) {
              this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
              this.isUmbrellaConcept = true
              this.selectedLicenseData = []
            } else if (!this.selectedLicenseData == null && this.isUmbrellaConcept == true) {
              this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
              this.isUmbrellaConcept = false
            }
          }
        } else {
          this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
        }
      } else if (checkCondition == '0') {
        this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
      } else if (this.stepData.requestType == 104) {
        let checkCondition = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
        let checkConcept = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICUMB').Value;
        if (checkCondition == 1) {
          if (checkConcept == 0) {
            this.logHelperService.logError({
              message: `Please select any license.`,
              html: true
            });
            return
          } else if (checkConcept == 1 && !this.stepData.isSubContractorFlowStarted) {
            this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
          } else {
            this.logHelperService.logError({
              message: `Please select any license.`,
              html: true
            });
            return
          }
        } else {
          this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
        }
      }

      if (this.licenseList.length === 0) {
        this.handleSave.emit({ License_Code: null, NewLicense_Code: null, isSkipLicense: true });
      }
    }
  }

  isStatusActive: any;
  isNewLicenseSelect: boolean = false
  onRowClicked({ data: selectedData }: any) {
    this.selectedLicenseData = []
    this.selectedLicenseData = selectedData
    this.isCheckValidation = true;

    this.isStatusActive = selectedData
    let oldContractor = this.dataShareService.oldLicenseFlowArrayDataShareService.filter(item => !item.isSubContractorFlowStarted) || [];
    let oldSubContractor = this.dataShareService.oldLicenseFlowArrayDataShareService.filter(item => item.isSubContractorFlowStarted) || [];

    if (this.isNewLicenseSelect == true && selectedData.Status === "Expired" || oldContractor.length > 0 && selectedData.Status === "Expired" || oldSubContractor.length > 0 && selectedData.Status === "Expired") {
      let remainingZeroMessage = this.alertMessages.find(item => item.Short_Code === 'MSG195_1');
      let checkCondition = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
      if (checkCondition === '1' && selectedData.Remaining < 1) {
        this.logHelperService.logError({
          message: remainingZeroMessage ? remainingZeroMessage.MSG : ""
        })
      } else if (checkCondition === '2' && selectedData.Remaining < 1) {
        this.logHelperService.logError({
          title: 'Warning!',
          message: remainingZeroMessage ? remainingZeroMessage.MSG : "",
        }, 'warning', 'Go to Next', true).then((res) => {
          if (res && res.value) {
            this.handleSave.emit({ ...selectedData });
          }
        })
      } else if (selectedData.Remaining > 0) {
        this.handleSave.emit({ ...selectedData, isSkipLicense: true });
      }
    }
    // console.log("GatePassRequestType type -->",GatePassRequestType.New)
    // if (this.stepData.requestType === GatePassRequestType.New && this.isCheckValidation && selectedData.Remaining <= 0) {
    //   this.logHelperService.logError({
    //     message: 'You cannot request more than license capacity also you are exceed as per CLRA without license capacity.'
    //   });

    //   return;
    // }

    if (this.parentLicenseCode) {
      this.handleSave.emit({ License_Code: this.parentLicenseCode, NewLicense_Code: selectedData.License_Code, isNew: true });
      if (this.stepData.isSubContractorFlowStarted) {
        selectedData.isSubContractorFlowStarted = true;
      }
      this.dataShareService.newLicenseFlowArrayDataShareService.push(selectedData);
      this.parentLicenseCode = null
      return;
    }
    if (this.stepData.requestType == 104 && selectedData.Status == 'Expired') {
        let msg = this.alertMessages.find(item => item.Short_Code === 'MSG195_15').MSG;
        this.logHelperService.logError({
          title: 'Warning!',
          message: msg,
          html: true
        }, 'warning', 'Go to Next', true).then((res) => {
          if (res && res.value) {
            if (this.stepData.requestType === GatePassRequestType.Renew) {
              this.parentLicenseCode = selectedData.License_Code;
              if (this.stepData.isSubContractorFlowStarted) {
                selectedData.isSubContractorFlowStarted = true;
              }
              this.dataShareService.oldLicenseFlowArrayDataShareService.push(selectedData);

              this.parentLicenseList = this.licenseList;
              this.licenseList = this.licenseList.filter(item => item.License_Code !== selectedData.License_Code && item.Plant_Code === selectedData.Plant_Code && item.Status != "Expired");
              this.isNewLicenseSelect = true
            }
          }
        })
    } else {
      if (this.verifyLicense == 1) {
        if (selectedData.Status !== 'Expired') {
          this.handleSave.emit({ ...selectedData });
        } else {
          this.logHelperService.logError({
            title: 'OOPS!!!',
            message: 'License is already expired! Please extend validity date for selected License. Or select other active License.'
          });
          return
        }
      }
      // } else if (this.verifyLicense == 0) {
        //   this.handleSave.emit({ ...selectedData });
      // }

      if (this.isHideRemaining) {
        if (selectedData.Status == "Expired") {
          if (!this.isHideSkip) {
            this.logHelperService.logError({
              title: 'OOPS!!!',
              // message: this.licenceExpireMessage.MSG
              message: "Selected license is expired. Please select active license or Skip the License selection option"
            });
            return
          }
        }
      }
      
      if (!this.isHideRemaining) {
        if (selectedData.Status == "Active") {
          if (selectedData.Remaining === 0 && this.stepData.requestType === GatePassRequestType.New) {
            this.logHelperService.logError({
              title: 'OOPS!!!',
              // message: this.licenceExpireMessage.MSG
              message: this.noremainingMsg.MSG
            });
          } else {
            let remainingZeroMessage = this.alertMessages.find(item => item.Short_Code === 'MSG195_1');
            let checkCondition = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
            if (checkCondition === '1' && selectedData.Remaining < 1 && this.stepData.requestType == 103) {
              this.logHelperService.logError({
                message: remainingZeroMessage ? remainingZeroMessage.MSG : ""
              })
              return
            } else if (checkCondition === '2' && selectedData.Remaining < 1 && this.stepData.requestType == 103) {
              this.logHelperService.logError({
                title: 'Warning!',
                message: remainingZeroMessage ? remainingZeroMessage.MSG : "",
              }, 'warning', 'Go to Next', true).then((res) => {
                if (res && res.value) {
                  this.handleSave.emit({ ...selectedData });
                }
              })
            } else if (selectedData.Remaining > 0 || this.stepData.requestType == 104 && !this.stepData.isNew) {
              if (this.stepData.isSubContractorFlowStarted) {
                selectedData.isSubContractorFlowStarted = true;
              }
              if (this.stepData.requestType !== 104) {
                this.handleSave.emit({ ...selectedData, isSkipLicense: true });
              } else {
                let checkCondition = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICCAP').Value;
                let concept = this.globalSettingCodes.find(item => item.Code === 'MOD52PG195REQLICUMB').Value;
                
                if (!this.isNewLicenseSelect) {
                  this.logHelperService.logError({
                    title: 'Warning!',
                    message: "Do you wan to change license for renewal request? ",
                    html: true
                  }, 'warning', 'Go to Next', true).then((res) => {
                    if (res && res.value) {
                      if (this.stepData.requestType === 104) {
                        this.dataShareService.oldLicenseFlowArrayDataShareService.push(selectedData);
                        this.licenseList = this.licenseList.filter(item => item.License_Code !== selectedData.License_Code && item.Plant_Code === selectedData.Plant_Code && item.Status != "Expired");
                        this.isNewLicenseSelect = true
                        if (checkCondition == 1 && concept == 0) {
                          this.isHideSkip = true
                        }
                        if (this.dataShareService.newLicenseFlowArrayDataShareService.length > 0 && checkCondition == 1 && concept == 1) {
                          this.isHideSkip = false
                        } else if (this.dataShareService.newLicenseFlowArrayDataShareService.length === 0 && checkCondition == 1 && concept == 1){
                          this.isHideSkip = true
                        }
                      }
                    } else {
                      this.dataShareService.oldLicenseFlowArrayDataShareService.push(selectedData);
                      this.handleSave.emit({ ...selectedData, isSkipLicense: true });
                    }
                  })
                } else {
                  if (checkCondition == 1 && this.stepData.requestType === 104 && this.isNewLicenseSelect) {
                    this.dataShareService.newLicenseFlowArrayDataShareService.push(selectedData);
                    this.handleSave.emit({ ...selectedData, isSkipLicense: true });
                  }
                }
              }
            }
            // this.handleSave.emit({ ...selectedData });
          }
        } else if (selectedData.Status == "Expired" && !this.isHideSkip) {
          if (this.stepData.requestType === GatePassRequestType.New) {
            this.logHelperService.logError({
              title: 'OOPS!!!',
              // message: this.licenceExpireMessage.MSG
              message: this.selectActiveMsg.MSG
            });
            return
          }
        } else if (selectedData.Status == "Expired" && this.isHideSkip) {
          if (this.stepData.requestType === GatePassRequestType.New) {
            if (this.selectedPlantDetail.LicenseMaxValue < this.selectedWorkOrderDetail.ActivePerson) {
              this.logHelperService.logError({
                title: 'OOPS!!!',
                message: "Selected license is expired also as per CLRA without license capacity also exceeded."
              });
              return
            } else {
              this.handleSave.emit({ ...selectedData });
            }
          }
        }
      } else {
        if (selectedData.Status != "Expired") {
          this.handleSave.emit({ ...selectedData });
        }
      }
    }
  }
  
  private createColumnDef() {
    this.columnDefs = [
      {
        headerName: '#', field: '',
        width: 30, filterParams: { applyButton: true }, cellRendererFramework: AgNumberCountComponent
      },
      {
        headerName: 'Licence', field: 'LicenseNo', wrapText: true, autoHeight: true,
        Width: 70, filterParams: { applyButton: true, clearButton: true }, sortable: true, filter: true
      },
      {
        headerName: 'Plant', field: 'PlantName',
        width: 50, filterParams: { applyButton: true, clearButton: true }, sortable: true, filter: false, textAlign: 'center'
      },
      {
        headerName: 'Person to be engaged', field: 'Person', width: 80, wrapHeaderText: true,
        autoHeaderHeight: true, filterParams:
          { applyButton: true, clearButton: true }, filter: false, cellStyle: { textAlign: 'center' },
      },
      {
        headerName: 'Active', field: 'ActivePerson', width: 40, filterParams:
          { applyButton: true, clearButton: true }, filter: true,
        hide: !this.isHideRemaining
      },
      {
        headerName: 'Remaining', field: 'Remaining', width: 60, filterParams:
          { applyButton: true, clearButton: true }, filter: false, cellStyle: { textAlign: 'center' },
        hide: this.isHideRemaining
      },
      {
        headerName: 'State', field: 'State', width: 60, filterParams: { applyButton: true, clearButton: true },
        suppressMenu: false, sortable: true, filter: false
      },
      {
        headerName: 'Issue Dt.', field: 'IssueDate', width: 60, filterParams: { applyButton: true, clearButton: true },
        sortable: false, suppressMenu: false, filter: false, cellStyle: { textAlign: 'center' },
        cellRenderer: ({ data }) => {
          return moment(data.IssueDate).format('DD/MM/YYYY');
        }
      },
      {
        headerName: 'Validity Dt.', field: 'ValidtyDate', width: 50, filterParams: { applyButton: true, clearButton: true },
        sortable: false, suppressMenu: false, filter: false, cellStyle: { textAlign: 'center' },
        cellRenderer: ({ data }) => {
          return moment(data.ValidtyDate).format('DD/MM/YYYY');
        }
      },
      {
        headerName: 'Status', field: 'Status', width: 60, filterParams: { applyButton: true, clearButton: true },
        sortable: false, suppressMenu: false, filter: false, cellStyle: { textAlign: 'center' },
        hide: this.showStatus == '0' ? true : false,
        cellRenderer: ({ data }) => {
          if (data.Status === 'Expired') {
            return `<span class="badge badge-danger">${data.Status}</span>`;
          }

          return `<span class="badge badge-success">${data.Status}</span>`;
        }
      },
      {
        headerName: 'Action', field: '', width: 50, filterParams: { applyButton: true, clearButton: true },
        sortable: false, suppressMenu: false, cellRendererFramework: AgSelectActionCellRendererComponent,
      }
    ];
  }

  private createGridOptions(): void {
    this.gridOptions = {
      context: {
        componentParent: this
      },
      getRowHeight: (params) => {
        return 37;
      },
      onGridReady: (params) => {
        this.gridAPI = params.api;
        params.api.sizeColumnsToFit();
      },
      onGridSizeChanged: (params) => {
        params.api.sizeColumnsToFit();
      },
      icons: {
        sortNone: '<i class="fa fa-sort" />',
        sortAscending: '<i class="fa fa-sort-alpha-asc" />',
        sortDescending: '<i class="fa fa-sort-alpha-desc" />'
      },
      pagination: true,
      paginationPageSize: 10,
      headerHeight: 40,
    };
  }

}